export default __webpack_public_path__ + "static/media/IMG_7799-1.4d0900bc.jpg";